var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLithuania(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5652C31.648 19.832 32 17.9572 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348L16 9.04352L0.995188 10.4348C0.352 12.1681 0 14.0429 0 16C0 17.9572 0.352 19.832 0.995188 21.5652L16 22.9565L31.0048 21.5652Z",
    fill: "#6DA544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.005 10.4348C28.7443 4.342 22.8796 0 16.0002 0C9.12074 0 3.25605 4.342 0.995361 10.4348H31.005Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32C22.8796 32 28.7443 27.658 31.005 21.5652H0.995361C3.25605 27.658 9.12074 32 16.0002 32Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLithuania);
export default __webpack_public_path__ + "static/media/lithuania.f9e017e8.svg";
export { ForwardRef as ReactComponent };